import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VendorLookUp'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VendorLookUpStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VendorLookUpStore",
			variables: true,
		})
	}
}

export async function load_VendorLookUp(params) {
  await initClient()

	const store = new VendorLookUpStore()

	await store.fetch(params)

	return {
		VendorLookUp: store,
	}
}
